import { useEffect, useState } from "react";
import { getExperience } from "../services/api";
import ScrollReveal from "../components/ScrollReveal";

export default function ExperienceSection() {
  const [experience, setExperience] = useState([]);

  useEffect(() => {
    getExperience()
      .then((res) => setExperience(res.data))
      .catch((err) => console.error(err));
  }, []);

  return (
    <section className="py-32 bg-white">
      <div className="max-w-5xl mx-auto px-6">

        {/* Header */}
        <ScrollReveal>
          <div className="mb-16 text-center">
            <p className="text-sm uppercase tracking-widest text-blue-600 font-semibold mb-4">
              Career Journey
            </p>
            <h2 className="text-3xl md:text-4xl font-semibold tracking-tight text-slate-900">
              Experience
            </h2>
          </div>
        </ScrollReveal>

        {/* Timeline */}
        <div className="relative border-l border-slate-200 ml-4">

          {experience.map((exp, index) => (
            <ScrollReveal key={index} delay={index * 0.1}>
              <div className="mb-16 ml-8 relative">

                {/* Timeline Dot */}
                <div className="absolute -left-11 top-2 w-4 h-4 bg-blue-600 rounded-full"></div>

                {/* Duration */}
                <p className="text-slate-500 text-sm mb-2">
                  {exp.duration}
                </p>

                {/* Role */}
                <h3 className="text-xl md:text-2xl font-semibold text-slate-900">
                  {exp.role}
                </h3>

                <p className="text-slate-600 mb-4">
                  {exp.company}
                  {exp.location && ` • ${exp.location}`}
                </p>

                <p className="text-slate-600 leading-relaxed">
                  {exp.description}
                </p>

                {exp.achievements && (
                  <ul className="mt-6 space-y-2 text-blue-600 text-sm">
                    {exp.achievements.split(",").map((a, i) => (
                      <li key={i}>✔ {a.trim()}</li>
                    ))}
                  </ul>
                )}

              </div>
            </ScrollReveal>
          ))}

        </div>

      </div>
    </section>
  );
}